import _extends from "@babel/runtime/helpers/extends";
import { COUNTRY_CODES } from '@wix/form-multiline-address';
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import { useCountryCode } from '../../multiline-address/multiline-address/country-code-context';
import JapanPostalCodeWUT from './japan-postal-code-wut';
export const MlaPostalCodeWUT = props => {
  const fieldType = FIELD_TYPES.MLA_POSTAL_CODE;
  const label = useAddressLabel('zipCode');
  const countryCode = useCountryCode();
  const isJapan = Boolean(countryCode && COUNTRY_CODES[countryCode] === COUNTRY_CODES.JP);
  return isJapan ? /*#__PURE__*/React.createElement(JapanPostalCodeWUT, _extends({}, props, {
    fieldType: fieldType,
    label: label
  })) : /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    label: label
  }));
};
//# sourceMappingURL=mla-postal-code-wut.js.map